/* eslint-disable @typescript-eslint/no-unused-vars */
const applicable = (resp) => resp?.config.url.match(/api\/forms\/[0-9]+$/g);

const cleanRuleCodesAndIds = (rule, isTopLevelRule?: boolean): void => {
	if(Array.isArray(rule.Children)) {
		rule.Children.forEach(r => cleanRuleCodesAndIds(r));
	}
	
	if(isTopLevelRule === true) {
		return;
	}

	if(rule.Id !== undefined) {
		delete rule.Id;
	}

	if(rule.Code !== undefined) {
		delete rule.Code;
	}
};

const modify = (resp) => {
	if(!resp.data?.Data) {
		return resp;
	}

	//const rules = resp.data.Data.Rules ?? [];

	//rules.forEach(r => cleanRuleCodesAndIds(r, true));

	return resp;
};

export const removeChildRuleCodesAndIds = [applicable, modify];